import { Component, inject } from '@angular/core';
import { QuickResponseCodeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  QuickResponseCodeCreateDto,
  QuickResponseCodeDto,
  QuickResponseCodeExcelDownloadDto,
  QuickResponseCodeUpdateDto,
} from '../proxy/general/dtos/quick-response-code';
import { QUICKRESPONSECODE_CONFIG, QUICKRESPONSECODE_FIELDS } from './quick-response-code.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-quick-response-code',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, QuickResponseCodeService, ConfirmationService],
  templateUrl: './quick-response-code.html',
  styleUrl: './quick-response-code.scss',
})
export class QuickResponseCode extends BaseCrudComponent<
  QuickResponseCodeDto,
  QuickResponseCodeCreateDto,
  QuickResponseCodeUpdateDto,
  QuickResponseCodeExcelDownloadDto
> {
  service = inject(QuickResponseCodeService);
  config = QUICKRESPONSECODE_CONFIG;
  fields = QUICKRESPONSECODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: QuickResponseCodeDto): QuickResponseCodeUpdateDto {
    return {
      qrCode: data.qrCode,
      isActive: data.isActive,
      deactivationReasonId: data.deactivationReasonId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'QuickResponseCode';
  }
}
